// extracted by mini-css-extract-plugin
export default {"requiredMarker":"RequiredMarker_requiredMarker__XLPRe"};